<template>
  <div>
    <section class="hero-section">
      <div class="hero-content">
        <h1>Multiservicios GMM</h1>
        <h2>Transformando Espacios, Creando Hogares</h2>
        <p>
          Bienvenidos a Multiservicios GMM. Somos un equipo apasionado de
          profesionales de la construcción dedicados a convertir tus sueños en
          realidad. Ya sea que necesites renovar tu hogar, construir desde cero
          o darle un nuevo aire a tus espacios, estamos aquí para ti.
        </p>
        <a href="#contacto" class="cta-button">¡Comienza tu proyecto!</a>
      </div>
    </section>

    <section class="servicios-section">
      <h3>Nuestros Servicios</h3>
      <div class="servicios-grid">
        <div class="servicio-card">
          <h4>Diseño y Planificación Personalizada</h4>
          <ul>
            <li>Diseño funcional y estético adaptado a ti</li>
            <li>Planos, acabados y detalles únicos</li>
          </ul>
        </div>
        <div class="servicio-card">
          <h4>Construcción y Remodelación</h4>
          <ul>
            <li>Equipo calificado y eficiente</li>
            <li>Calidad y atención al detalle</li>
          </ul>
        </div>
        <div class="servicio-card">
          <h4>Experiencia en Diversos Proyectos</h4>
          <ul>
            <li>Cocinas, baños, jardines, ampliaciones</li>
            <li>Galería de trabajos anteriores</li>
          </ul>
        </div>
      </div>
    </section>

    <section class="por-que-section">
      <h3>¿Por Qué Elegirnos?</h3>
      <div class="por-que-grid">
        <div class="por-que-card">
          <h4>Compromiso con la Excelencia</h4>
          <p>Superamos expectativas con resultados de alta calidad.</p>
        </div>
        <div class="por-que-card">
          <h4>Transparencia y Comunicación</h4>
          <p>Comunicación abierta y constante. Tu satisfacción es clave.</p>
        </div>
        <div class="por-que-card">
          <h4>Inspiración y Creatividad</h4>
          <p>Diseño innovador que refleja tu estilo y personalidad.</p>
        </div>
      </div>
    </section>

    <section class="contacto-section" id="contacto">
      <h3>Contáctanos</h3>
      <p>¿Listo para comenzar tu próximo proyecto? ¡Hablemos!</p>
      <p class="mb-2">
        📞 Llámanos al
        <a
          href="https://wa.me/573224452460"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none fw-bold"
        >
          +57-322 445 2460
        </a>
      </p>

      <p>
        📧 Escríbenos a
        <a
          href="mailto:ventas@multiserviciosgmm.com"
          class="text-decoration-none fw-bold"
        >
          ventas@multiserviciosgmm.com
        </a>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "HeroSection",
};
</script>

<style>
.hero-section {
  background: linear-gradient(135deg, #0f9d58, #00acc1);
  color: white;
  padding: 60px 20px;
  text-align: center;
}

.cta-button {
  background-color: #ffffff;
  color: #0f9d58;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: bold;
  text-decoration: none;
  margin-top: 20px;
  display: inline-block;
}

.servicios-section,
.por-que-section,
.contacto-section {
  padding: 40px 20px;
  background-color: #f5f5f5;
}
.contacto-section p {
  text-align: center;
  font-size: 1.2em;
}

.servicios-grid,
.por-que-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.servicio-card,
.por-que-card {
  background-color: white;
  border-left: 6px solid #00acc1;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
}

h1,
h2,
h3,
h4 {
  color: #034023;
}
</style>
